import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const WeatherService = {};
WeatherService.getOverallCATbyLocation = async function (lat, lng) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/weather/get/cat",
        params: {
            lat,
            lon: lng,
        },
        headers: {
            "Content-Type": "application/json",
        }
    });
}
export default WeatherService;